module.exports = __webpack_public_path__ + "img/shouji.47246460.png";